import { patchRequest } from "@react/helpers/fetch"

export const updateBankGuarantee = (projectId, body) =>
  patchRequest({ url: `/projects/${projectId}/bank_guarantee.json`, body: { bank_guarantee: body } })
